<template>
  <div v-if="config.total > 0" class="d-flex justify-content-between align-items-center flex-wrap">
    <div class="pagination d-flex flex-wrap py-2 mr-3">
      <button type="button" @click="goPage('first')" :disabled="page == 1" class="btn btn-text btn-icon btn-sm btn-outline-primary mr-1 my-1">
        <i class="ri-skip-back-mini-line"></i>
      </button>
      <button type="button" @click="goPage('prev')" :disabled="page == 1" class="btn btn-text btn-sm btn-outline-primary mr-1 my-1"> {{ $t("global.prev") }} </button>
      <input @change="goPage('input')" v-model.lazy="page" type="text" name="pagination" autocomplete="off" class="form-control form-control-sm pagination-text mr-1 my-1" :placeholder="$t('global.goto')" />
      <button type="button" @click="goPage('next')" :disabled="page == maxPage" class="btn btn-text btn-sm btn-outline-primary mr-1 my-1"> {{ $t("global.next") }} </button>
      <button type="button" @click="goPage('last')" :disabled="page == maxPage" class="btn btn-text btn-icon btn-sm btn-outline-primary mr-1 my-1">
        <i class="ri-skip-forward-mini-line"></i>
      </button>
    </div>
    <div class="d-flex align-items-center py-3">
      <div v-if="config.isLoading" class="d-flex align-items-center">
        <div class="mr-2 text-muted">{{ $t("global.loading") }} ...</div>
        <div class="spinner spinner-primary mr-10"></div>
      </div>
      <v-select class="limit-table mr-4" placeholder="Limit Data" v-model="limit" :value="limit" append-to-body :searchable="false" :clearable="false" :options="[10, 20, 50, 100]"></v-select>
      <span class="text-muted">{{ detailPagination }}</span>
    </div>
  </div>
</template>

<script>
// config:{
//   total:0, NUMERIC
//   limit:10, NUMERIC
//   isLoading:true, BOOLEAN
// }
export default {
  name: 'pagination',
  props: {
    config: { type: Object, required: true, default: () => ({}) }
  },
  data () {
    return {
      maxPage: 1,
      page: 1,
      limit: 10,
      offset: 0
    }
  },
  mounted () {
    if (this.page < 1) this.page = 1
    if (!this.config.limit) this.config.limit = 10
    if (!this.config.total) this.config.total = 0
    this.maxPage = Math.ceil(this.config.total / this.config.limit)
  },
  computed: {
    detailPagination () {
      let _inPage =
        this.config.limit > this.config.total
          ? this.config.total
          : this.config.limit
      return (
        this.$t('global.display') +
        ' ' +
        _inPage +
        ' ' +
        this.$t('global.of') +
        ' ' +
        `${this.config.total}` +
        ' ' +
        this.$t('global.record')
      )
    }
  },
  watch: {
    limit: {
      handler (to) {
        this.emitEvent(this.page, to)
      }
    },
    page: {
      handler (to) {
        this.page = to
      }
    },
    config: {
      deep: true,
      immediate: true,
      handler (to) {
        this.maxPage = Math.ceil(to.total / to.limit)
        if (this.page >= this.maxPage) this.page = this.maxPage || 1
        setTimeout(() => {
          this.isLoading = to.isLoading
        }, 500)
      }
    }
  },
  methods: {
    emitEvent (page, limit = this.config.limit) {
      let value = {
        limit: limit,
        offset: page > 1 ? (page - 1) * limit : 0,
        page: page || 1
      }
      this.$emit(`paginate`, value)
    },
    goPage (e) {
      switch (e) {
        case 'first':
          this.page = 1
          break
        case 'last':
          let a = this.maxPage / this.config.limit
          this.page = a - parseInt(a) > 0 ? parseInt(a.toFixed(0)) + 1 : a
          break
        case 'next':
          this.page =
            this.page < this.maxPage ? Number(this.page) + 1 : this.page
          break
        case 'prev':
          this.page = this.page === 1 ? this.page : Number(this.page) - 1
          break
        case 'input':
          if (!isNaN(this.page)) {
            if (this.page > this.maxPage) {
              this.page = this.maxPage
            } else if (this.page < 1) this.page = 1
          }
          break
      }
      this.emitEvent(this.page)
    }
  }
}
</script>

<style scoped>
  .pagination-text {
    width: 80px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/base/component/_pagination.vue